import React from 'react'
import ReactGA from 'react-ga';
import { MuiThemeProvider } from '@material-ui/core/styles';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import theme from './theme';
// import WebLinks from './routes';
import Header from "./features/header";
import Footer from "./features/footer";
import Home from "./features/home";
import ThankYou from "./features/thankyou";
import Articles from "./features/articles";
import Leadership from "./features/leadership";
import Contact from "./features/contact";
import NoMatch from "./features/nomatch";

const GATracking = 'UA-33732039-1';

ReactGA.initialize(GATracking, {
    debug: true,
    titleCase: false,
});
ReactGA.ga('set', 'checkProtocolTask', null);

const App = () => {
    return (
    <MuiThemeProvider theme={theme}>
        <BrowserRouter>
            <Header />
            {/*<WebLinks />*/}
            <Routes>
                <Route path='/' element={<Home />} />
                <Route path='thankyou' element={<ThankYou />} />
                <Route path='articles' element={<Articles />} />
                <Route path='leadership' element={<Leadership />} />
                <Route path='contact' element={<Contact />} />
                <Route path='*' element={<NoMatch />} />
            </Routes>
            <Footer />
        </BrowserRouter>
    </MuiThemeProvider>
    );
}

export default App;
